import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServiceSidebar from './ServiceSidebar';
import './Service.css';

const EmbryoTransfer = () => {
  return (
    <div className="service-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>Embryo Transfer in Ambala | IVF Procedure | Amaanat IVF</title>

        <meta
          name="description"
          content="Embryo transfer procedure in Ambala at Amaanat IVF. Safe, painless IVF step with high implantation success rates."
        />

        <link rel="canonical" href="https://amaanativf.com/services/embryo" />

        {/* ✅ Medical Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalProcedure",
            "name": "Embryo Transfer",
            "description": "Final stage of IVF where embryo is transferred into uterus",
            "procedureType": "Therapeutic",
            "bodyLocation": "Uterus",
            "location": {
              "@type": "MedicalClinic",
              "name": "Amaanat IVF",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Ambala",
                "addressCountry": "India"
              }
            }
          })}
        </script>

        {/* ✅ FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Is embryo transfer painful?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Embryo transfer is usually painless and does not require anesthesia."
                }
              },
              {
                "@type": "Question",
                "name": "How long does embryo transfer take?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The procedure typically takes around 10–15 minutes."
                }
              },
              {
                "@type": "Question",
                "name": "What happens after embryo transfer?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "After transfer, patients are advised rest and a pregnancy test is done after 10–12 days."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <section className="service-hero">
        <div className="container">

          <h1>Embryo Transfer in Ambala</h1>

          <p>
            Final step of IVF treatment to achieve successful pregnancy
          </p>

          <div className="hero-stats">
            <span>10 min</span> Painless Procedure
          </div>

        </div>
      </section>

      {/* MAIN */}
      <div className="services-layout container">

        <ServiceSidebar />

        <div className="services-content">

          <section>
            <h2>What is Embryo Transfer in IVF?</h2>
            <p>
              Embryo transfer is the final stage of IVF treatment where the best quality
              embryo is carefully placed into the uterus to achieve pregnancy.
            </p>
          </section>

          <section>
            <h2>Benefits of Embryo Transfer</h2>
            <ul>
              <li>Painless and quick IVF procedure</li>
              <li>No anesthesia required</li>
              <li>High implantation success rate</li>
            </ul>
          </section>

          {/* ✅ Hidden SEO Block */}
          <section style={{ marginTop: "40px" }}>
            <h2>Best IVF Embryo Transfer Centre in Ambala</h2>
            <p>
              Amaanat IVF provides advanced embryo transfer procedures in Ambala with
              high success rates. Our experienced embryologists ensure precise embryo placement,
              increasing the chances of successful implantation and pregnancy.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default EmbryoTransfer;